import './AuditDetails.css';
import React, { useState, useEffect} from 'react';
import moment from 'moment';
import LoadingSpinner from "../../components/loadSpinner/LoadingSpinner.jsx";
import { requestGetAuditLogs } from '../../services/wisdomServices/auditService.js';
import { Calendar } from 'primereact/calendar';
import { FloatLabel } from 'primereact/floatlabel';
import WisdomDataTable from '../../components/dataTable/WisdomDataTable.jsx';

/**
 * @function AuditDetails
 * @returns {JSX.Element} - audit logs details page
 */
function AuditDetails() {
  const today = new Date()
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [dates, setDates] = useState([
    today,
    today
  ])
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading,setLoading] = useState(true);

  const columns = [
    {
      field: 'id',
      header: 'Id'
    },
    {
      field: 'action',
      header: 'Action'
    },
    {
      field: 'level',
      header: 'Type'
    },
    {
      field: 'message',
      header: 'Log Details'
      
    },
    {
      field: 'timeStamp',
      header: 'TimeStamp'
    },
  
  ];

  /**
   * @async
   * @function getAuditLog
   * @description - fetches audit log records from the API based on the selected date range
   */
  const getAuditLog = async(ranges, page, rows) => {
    if(!ranges?.[0] || !ranges?.[1]) return
    let audits = [];

    try {
      setLoading(true);
      const startDate = moment(ranges[0]).format("YYYY-MM-DD");
      const endDate = moment(ranges[1]).format("YYYY-MM-DD");
      let auditResult = await requestGetAuditLogs(startDate, endDate, page, rows)
      const {data, pagination} = auditResult
      setTotalRecords(pagination.totalResults)
      for (const item of data) {
        let audit = {
        id : item.id,
        action: item.action,
        message : item.details,
        level : item.entityType,
        timeStamp : item.timestamp
        }
        audits.push(audit);
      }
      
    } catch (error) {
      console.error(error)

    } finally {
      setAuditLogs(audits);
      setLoading(false);

    }

  }

  const handleDateRangeChange = async(e) => {
    setDates(e.value)
    getAuditLog(e.value)
  }

  const tableHeader = (
    <div className='audit-details-input-box'>
      <FloatLabel>
        <Calendar value={dates} onChange={handleDateRangeChange} selectionMode='range' readOnlyInput hideOnRangeSelection inputId="audit-details-date-range-selector"/>
        <label htmlFor="audit-details-date-range-selector">Select a date range</label>
      </FloatLabel>
    </div>
  )

  const onPageChange = (event) => {
    setPage(event.page + 1);
    setRows(event.rows);
    setFirst(event.first);
  };

  useEffect(() => {
    getAuditLog(dates, page, rows);
  }, [dates, page, rows]);

  return (
    
    <div className='audit-logs-page'>
       
      <h1 className='audit-logs-page-title'>Audit Log</h1>
      <WisdomDataTable 
        header={tableHeader}
        data={auditLogs}
        columns={columns}
        rows={rows}
        totalRecords={totalRecords}
        onPage={onPageChange}
        first={first}
        loading={loading}
      />
    </div>
  );
}

export default AuditDetails;
